define('views/shared/header/balance',[
    'views/_base/baseview',
    'text!views/shared/header/balance.html'
], function(BaseView, Template){
    'use strict';

    return BaseView.extend({
        id      : 'account-balance-container',
        tagName : 'span',
        isRender: false,
        template: _.template(Template),
        events  : {},
        initialize: function(options){
            options = options || {};

            this.spending_account = null;
            this.sa_interval = null;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(temp_balance){

            if(this.spending_account){
                this.account_balance = formatBalanceCurrency(this.spending_account.balance);
            }

            $('.js-pf-account-balance-loader').remove();
            $('.js-pf-account-balance-container').removeClass('hidden');

            this.$el.html(this.template());

            clearInterval(this.sa_interval);

            return this;
        },

        loadData: function(){
            var that = this;

            if(pf.IsConsumerFinancial){

                if(pf.accounts && pf.accounts.spending_account){
                    this.spending_account = pf.accounts.spending_account;
                    this.render();
                } else {

                    this.sa_interval = setInterval(function(){

                        if(pf.accounts && pf.accounts.spending_account){
                            that.spending_account = pf.accounts.spending_account;
                            that.render();
                        }

                    },3000);
                }

            } else {
                this.account_balance = '&#160;&#160;&#160;--&#160;&#160;&#160;';
                this.render();
            }

        },

        updateData: function(spending_account){
            this.spending_account = spending_account;
            this.render();
        },

        close: function () {}
    });
});

